import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { manageUserStyles } from '../../Styles/adminStyles';
import { inject, observer } from 'mobx-react';
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Header from '../../Common/Header'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import AddUser from './AddUser';
import Loader from 'react-loader-spinner';
import DeleteDialog from '../../Common/DeleteDialog';
import AdminChangePassword from './AdminChangePassword'
import Tooltip from '@material-ui/core/Tooltip';
import BlockDialog from './BlockDialog';
import BlockIcon from '@material-ui/icons/Block';
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.dullGray,
        color: theme.palette.white,
        boxShadow: theme.shadows[1],
        fontSize: '13px',
    },
}))(Tooltip);
@inject('userStore', 'adminStore', 'commonStore')
@observer
class BlockedList extends Component {
    state = {
        pagination: {
            low: 0,
            high: 10,
            page: 0
        },
        notFoundMessage: 'No entries found',
        currentIp: '',
        currentDomain: ''
    }

    constructor(props) {
        super(props);
        this.childTwo = React.createRef();
    }

    componentDidMount() {
        this.props.commonStore.setActiveTab(this.props.active);
        this.props.adminStore.resetSearch()
        this.props.adminStore.getBlockedList(this.props.filter)
    }

    handleCloseMenu = () => {
        this.props.adminStore.resetIPMenuArray()
    }

    confirmDelete = () => {
        this.props.adminStore.deleteUser(this.state.currentUser._id);
    }

    deleteUser = (user) => {
        this.setState({ currentUser: user, deleteDialog: true });
        this.handleCloseMenu()
    }

    cancelDelete = () => {
        this.setState({ deleteDialog: false })
    }

    sortList = (sortType, index, field) => {
        this.props.adminStore.sortBlockedList(this.props.filter, field, sortType)
    }





    renderNotFoundMessage = (message) => {
        const { classes } = this.props;
        return (
            <div className={classes.noUserMessage}>
                <span style={{ display: 'table-cell', verticalAlign: 'middle' }} className={classes.docHeader}>{message}</span>
            </div>
        )
    }

    getPage = (type) => {
        const { pagination } = this.state;
        const { totalBlocked } = this.props.adminStore;
        const { user } = this.props.userStore;
        if (type === 'prev' && pagination.page - 1 > -1) {
            const temp = Object.assign({}, pagination, {
                low: pagination.low - 10,
                high: pagination.high - 10,
                page: pagination.page - 1
            });
            this.props.adminStore.setPageNumber(temp.page);
            this.props.adminStore.getBlockedList(this.props.filter)
            this.setState({ pagination: temp })
        }
        else if (type === 'next' && !(Math.ceil(totalBlocked / 10) * 10 == pagination.high)) {
            const temp = Object.assign({}, pagination, {
                low: pagination.low + 10,
                high: pagination.high + 10,
                page: pagination.page + 1
            });
            this.props.adminStore.setPageNumber(temp.page);
            this.props.adminStore.getBlockedList(this.props.filter)
            this.setState({ pagination: temp })
        }


    }

    renderPagination = () => {
        const { pagination } = this.state;
        const { classes } = this.props;
        let temp = pagination.high;
        const { totalBlocked } = this.props.adminStore;
        if (totalBlocked <= temp)
            temp = totalBlocked;
        return (
            <div className={classes.pagination}> {pagination.low + 1}-{temp} of {totalBlocked}
                <ChevronLeftIcon className={classes.icons} onClick={(e) => this.getPage('prev')} />
                <ChevronRightIcon className={classes.icons} onClick={(e) => this.getPage('next')} />
            </div>
        )
    }

    renderTableHead = () => {
        const { ipTableHeader } = this.props.adminStore;
        const { classes, filter } = this.props;
        const { user } = this.props.userStore;
        return (
            <TableHead>
                {
                    ipTableHeader.map((row, index) => (
                        (
                            row['category'].indexOf(filter.toLowerCase()) >= 0 ? 
                            <TableCell key={index} className={classes.tableHeader} style={{ width: row.width }} align="left">
                                <div style={{ display: 'flex' }}>
                                    {row.name}
                                    {row.allowSort ? (row.sort === 1 ?
                                        <ReactSVG className={classes.sortIcons} src={Images.sort} onClick={(e) => this.sortList(-1, index, row.type)} /> :
                                        <ReactSVG className={classes.sortIcons} src={Images.reverseSort} onClick={(e) => this.sortList(1, index, row.type)} />)

                                        : null}
                                </div>
                            </TableCell> : null

                        )
                    ))
                }
                <TableCell className={classes.tableHeader} style={{ width: '10vw' }} align="left">
                    {this.renderPagination()}
                </TableCell>

            </TableHead>

        )
    }

    renderUserName = (user) => {
        const { classes } = this.props;
        return (
            <div className="rowFlex">
                {user.userFullName}
                {
                    user.newEmail &&
                    <LightTooltip title={`Email verification pending for new email - ${user.newEmail}`} aria-label="add">
                        <ReactSVG className={classes.sortIcons} src={Images.error} />
                    </LightTooltip>

                }
            </div>
        )

    }

    openBlockDialog = (user) => {
        this.setState({ currentUser: user });
        this.props.adminStore.openBlockDialog(true);
    }

    renderTableContent() {
        const { classes, filter } = this.props;
        const { blockedList, pageNo } = this.props.adminStore;
        const { user } = this.props.userStore;
        return (
            <TableBody>
                {blockedList.map((row, index) => (
                    <TableRow key={row._id} className={classes.tableRow}>
                        <TableCell className={classes.tableData} align="left">{pageNo * 10 + index + 1}</TableCell>
                        <TableCell className={classes.tableData} align="left" >{filter === 'IP' ? row.ip : row.domain}</TableCell>
                        <TableCell className={classes.tableData} align="left">{Moment(row.createdAt).format('DD/MM/YYYY, h:mm a')}</TableCell>
                        <TableCell className={classes.tableData} align="left"><Tooltip title="Unblock"><BlockIcon style={{cursor: 'pointer'}} onClick={(e) => this.unblock(row)} /></Tooltip></TableCell>
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    renderBlockedTable = () => {
        const { classes } = this.props;
        return (
            <TableContainer style={{ height: '90%', backgroundColor: this.props.theme.palette.dark, overflowX: 'hidden' }} elevation={0} component={Paper}>
                <Table className={classes.table} style={{ maxWidth: '65%' }} aria-label="simple table">
                    {this.renderTableHead()}
                    {this.renderTableContent()}

                </Table>
            </TableContainer>
        )
    }

    block = () => {
        this.setState({ type: 'block', currentIp: '', currentDomain: '' })
        this.props.adminStore.openBlockDialog(true);
    }

    renderMenu = (index, row) => {
        const { ipMenuArray } = this.props.adminStore;
        const { classes } = this.props
        return (
            <React.Fragment>
                <MoreVertIcon className={classes.activeMore} onClick={(e) => this.props.adminStore.openIPMenu(e, index)} />
                <Menu
                    elevation={1}
                    id="simple-menu"
                    anchorEl={ipMenuArray[index]}
                    keepMounted
                    open={Boolean(ipMenuArray[index])}
                    onClose={(event) => { this.handleCloseMenu() }}
                    classes={{
                        list: classes.menuItems
                    }}
                >
                    <MenuItem onClick={(event) => this.unblock(row)} >Unblock</MenuItem>
                    <MenuItem onClick={(event) => this.handleCloseMenu(row)}>Delete</MenuItem>
                </Menu>
            </React.Fragment>
        )
    }

    unblock = (row) => {
        if (this.props.filter === 'IP') {
            this.setState({ currentIp: row.ip, currentDomain: '', type: 'unblock' });
        }
        else
            this.setState({ currentIp: '', currentDomain: row.domain, type: 'unblock' });
        this.props.adminStore.openBlockDialog(true)


    }

    render() {
        const { classes, theme, heading, filter } = this.props;
        const { blockedList, inProgress } = this.props.adminStore;
        const { type, currentIp, currentDomain } = this.state;

        return (
            <div style={{ height: '100%' }}>
                <div className={classes.outerContainer}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flex: '2', marginRight: '1vw' }}>
                        <div><Typography className={classes.heading}>{heading}</Typography></div>
                        <div>
                            <Button variant="contained" className={classes.button} type="submit" onClick={this.block} >{filter === 'IP' ? 'Block IP' : 'Block Domain'}</Button>
                        </div>
                    </div>
                    <Header searchType="blockList" filter={this.props.filter}></Header>
                </div>
                {
                    inProgress ?
                        <div style={{ height: '100%' }}>
                            <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                        </div> :
                        (blockedList && blockedList.length ?
                            this.renderBlockedTable() :
                            this.renderNotFoundMessage(this.state.notFoundMessage))
                }
                <BlockDialog ip={currentIp} domain={currentDomain} type={type} filter={filter}></BlockDialog>
            </div>
        )
    }
}

BlockedList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(manageUserStyles, { withTheme: true })(withRouter(BlockedList));
